export enum ResultRequestType {
  AppealRequest = 'appeal',
  ExportRequest = 'export-request',
  Attestation = 'attestation',
  DataAccessRequest = 'data-access-request',
  ImportRequest = 'import-request'
}

/**
 * `NotRequired` covers unrestricted requests and legacy results with no preparation state.
 * Only `Ready` permits a download.
 */
export enum DataAccessRequestParticipantFileStatus {
  NotRequired = 'NotRequired',
  Preparing = 'Preparing',
  Ready = 'Ready',
  Failed = 'Failed'
}

export enum UploadedFileProvider {
  Aws = 'AWS',
  Azure = 'Azure'
}
